import {
  faFacebook,
  faFacebookSquare,
  faInstagram,
  faInstagramSquare,
  faTwitch,
  faTwitter,
  faTwitterSquare,
  faYoutube,
  faYoutubeSquare,
} from "@fortawesome/free-brands-svg-icons";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment/moment";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledFooter = styled.footer`
  width: 100%;
  margin: 0 auto;
  padding: 30px 0px 0px 0px;
  text-align: center;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  background-image: linear-gradient(
    to right,
    #fbd314 0% 25%,
    #057138 25% 50%,
    #05a0dc 50% 75%,
    #ee7d09 75% 100%
  );
  background-size: 100% 5px;
  background-repeat: no-repeat;
  background-position: 100% 0;
`;

const StyledSocialMediaLinks = styled.section`
  display: flex;
  column-gap: 20px;
  justify-content: center;
  align-items: center;
  padding: 30px 0px 20px 0px;
  svg {
    font-size: 30px;
    transition: color 0.5s ease;
    &:hover {
      transition: color 0.5s ease;
    }
    &.facebook {
      color: #1877f2;
      &:hover {
        color: rgb(14, 96, 202);
      }
    }
    &.twitter {
      color: #000000;
      &:hover {
        color: #767676;
      }
    }
    &.instagram {
      color: #f251b8;
      &:hover {
        color: rgb(201, 46, 144);
      }
    }
    &.youtube {
      color: #ff0000;
      &:hover {
        color: rgb(186, 4, 4);
      }
    }
  }
`;

const StyledOtherLinks = styled.section`
  display: flex;
  column-gap: 20px;
  justify-content: center;
  align-items: center;
  a {
    font-size: 14px;
    font-weight: normal;
    color: #767676;
    text-decoration: none;
    transition: color 0.5s ease;
    &:hover {
      color: #000000;
      transition: color 0.5s ease;
    }
  }
`;

const StyledCopyrights = styled.p`
  font-size: 14px;
  font-weight: normal;
  color: #767676;
  padding: 0px 0px 30px 0px;
  margin: 0px;
`;

const Footer = () => {
  return (
    <StyledFooter>
      <StyledSocialMediaLinks>
        <a href="#" target="_blank">
          <FontAwesomeIcon icon={faFacebook} className="facebook" />
        </a>
        <a href="#" target="_blank">
          <FontAwesomeIcon icon={faX} className="twitter" />
        </a>
        <a href="#" target="_blank">
          <FontAwesomeIcon icon={faInstagram} className="instagram" />
        </a>
        <a href="#" target="_blank">
          <FontAwesomeIcon icon={faYoutube} className="youtube" />
        </a>
      </StyledSocialMediaLinks>
      <StyledOtherLinks>
        <Link to="/privacy-policy" title="Privacy Policy">
          Privacy Policy
        </Link>
        <Link to="/disclaimers" title="Disclaimers">
          Disclaimers
        </Link>
        <Link to="/terms-and-conditions" title="Terms and Conditions">
          Terms &amp; Conditions
        </Link>
        <Link to="/refund-policy" title="Refund Policy">
          Refund Policy
        </Link>
      </StyledOtherLinks>
      <StyledCopyrights>
        &copy; Copyrights {moment().year()}. All Rights Reserved.
      </StyledCopyrights>
    </StyledFooter>
  );
};

export default Footer;
